import axios, { AxiosResponse } from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { useContext } from "react";
import MainNav from "../components/Navbar/MainNav";
import { Context } from '../context/Context';
import Spinner from "../spinner/Spinner";
import LoginBG from '../assets/images/login_bg1.jpg'
import LoginTablet from '../assets/images/login_bg_tablet.jpg'
import LoginMobile from '../assets/images/login_bg_mobile.jpg'
import { useForm, SubmitHandler, useFormState } from 'react-hook-form';
import {axiosInstance} from '../../src/utils';

type RegProps = {
  username: string,
  email: string,
  password: string
}


const Register: React.FC = () => {
  //iniitailize form properties
  const { register, handleSubmit, watch, formState: { errors } } = useForm<RegProps>();
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
  });
  const [err, seterr] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value);
    setFormData(prevFormData => {
      return {
        ...prevFormData,
        [e.target.name] : e.target.value
      }
    })
  }

  const onSubmit: SubmitHandler<RegProps> = async (data) => {
    setLoading(true)
    try{
      const res = await axiosInstance.post("/auth/register", {
        username: data.username,
        email: data.email,
        password: data.password
      })
      setSuccess(true);
      setLoading(false)
      setTimeout(() =>{
        {res.data && window.location.replace('/login')}
      },2000)
    }catch(err) {
      seterr(true);
    }
  }

  return (
    <div>
      <MainNav />
        {success && <div className="success">Form submitted Successfully</div>}
        <div className='login__reg__wrapper'>
          {/* <h1>register</h1> */}
          <img src={LoginBG} alt="" className="desktop_bg" />
          <img src={LoginTablet} alt="" className='login_tablet' />
          <img src={LoginMobile} alt="" className='login_mobile' />
          <div className="login__reg__contents">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="input__wrap">
                <input 
                  {...register("username", { required: true })} 
                  type="text" 
                  name="username" 
                  placeholder='username' 
                  onChange={handleChange}
                />
                <span className="error">{errors.username?.type === 'required' && "Username is required"}</span>
              </div>
              <div className="input__wrap">
                <input 
                  {...register("email", { required: "Email is required", pattern:{
                    value: /\S+@\S+\.\S+/,
                    message: "Entered value does not match email format"
                  } })} 
                  type="email" 
                  name="email" 
                  placeholder='email' 
                  onChange={handleChange}
                />
                <span className="error">{errors.email && errors.email.message}</span>
              </div>
              <div className="input__wrap">
                <input 
                  {...register("password", { required: true })} 
                  type="password" 
                  name="password" 
                  placeholder='password' 
                  onChange={handleChange}
                />
                <span className="error">{errors.password?.type === 'required' && "Password is required"}</span>
              </div>
              {/* <input type="submit" value="submit" /> */}
              <button type="submit">Submit {loading && <Spinner /> }</button>
            </form>
          </div>
        </div>
    </div>
  )
}

export default Register
